import React from "react";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import "./navbar.css";

const NavigationBar = () => {

  const location = useLocation();
  const navigate = useNavigate();

  const isAdmin = localStorage.getItem("adminAuth");

  const isActive = (path) => location.pathname === path;

  const handleLogout = () => {

    localStorage.removeItem("adminAuth");

    navigate("/");

    window.location.reload();
  };

  return (
    <Navbar expand="lg" className="custom-navbar fixed-top">
      <Container>

        {/* Logo */}
        <Navbar.Brand href="/" className="navbar-logo">
          <img
            src="/Lismount.png"
            alt="linen Fabrics Logo"
            className="logo-img"
          />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />

        <Navbar.Collapse id="basic-navbar-nav">

          <Nav className="ms-auto align-items-center nav-links">

            <Nav.Link
              href="/"
              className={`nav-link ${isActive("/") ? "active-nav" : ""}`}
            >
              Home
            </Nav.Link>

            <Nav.Link
              href="/about"
              className={`nav-link ${isActive("/about") ? "active-nav" : ""}`}
            >
              About
            </Nav.Link>

            <Nav.Link
              href="/product"
              className={`nav-link ${isActive("/product") ? "active-nav" : ""}`}
            >
              Product
            </Nav.Link>

            <Nav.Link
              href="/business"
              className={`nav-link ${isActive("/business") ? "active-nav" : ""}`}
            >
              Our Business
            </Nav.Link>

            <Nav.Link
              href="/contact"
              className={`nav-link ${isActive("/contact") ? "active-nav" : ""}`}
            >
              Contact
            </Nav.Link>

            {/* ADMIN PROFILE MENU */}

            {isAdmin && (

              <NavDropdown
                title={
                  <span className="admin-profile">
                    👤 Admin
                  </span>
                }
                id="admin-menu"
                align="end"
              >

                <NavDropdown.Item
                  onClick={() => navigate("/admin-dashboard")}
                >
                  Dashboard
                </NavDropdown.Item>

                <NavDropdown.Divider />

                <NavDropdown.Item
                  onClick={handleLogout}
                >
                  Logout
                </NavDropdown.Item>

              </NavDropdown>

            )}

          </Nav>

        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavigationBar;